import { RefreshIcon } from "../../Assets/assets";


function SummaryHeader(props) {
  return (
    <div
      className=" display-flex flex-justify-content-space-between padding-bottom-large"
      style={{
        color: "var(--tertiaryColor)"
      }}
    >
      <div>SUMMARY</div>
      <div className=" display-flex flex-align-items-center">
        <div className=" padding-right-large">
          {props.summaryLastRefreshedAt ? (
            <div
              className=" font-size-small"
              style={{
                color: "var(--tertiaryColor5)"
              }}
            >
              Last refreshed at {remainingTime(props.summaryLastRefreshedAt)}{" "}
              ago
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          className={` display-flex flex-align-items-center ${props.isLoading ? "cursor-no-drop" : "cursor-pointer"} `}
          onClick={()=>{
            if(!props.isLoading){
              props.refreshOnClick()
            }
          }}
        >
          <RefreshIcon />
          <div className="padding-left-default">Refresh</div>
        </div>
      </div>
    </div>
  );
}

export default SummaryHeader;

export function remainingTime(timestamp) {
  const positiveTimestamp = Math.abs(+new Date() - timestamp);
  let seconds = Math.floor(positiveTimestamp / 1000);
  let minutes = Math.floor(seconds / 60);
  // let hours = Math.floor(minutes / 60);
  // let days = Math.floor(hours / 24);

  seconds %= 60;
  minutes %= 60;
  // hours %= 24;

  // const pad = (num) => String(num).padStart(2, "0");

  return `${minutes}m`;
}
